import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CircleCheck, Trash2, XCircle } from 'lucide-react';
import { LoadingSpinner } from '../../ui/loading-spinner';
import { cn } from '@airia/ui';
const PlaybookListItem = ({ playbook, onClick, onDelete }) => {
    const { name, status } = playbook;
    const getBgStyle = () => {
        if (status === 'Failed') {
            return 'bg-error-muted border-error text-error';
        }
        return 'bg-card';
    };
    const handleDeleteClick = (e) => {
        e.stopPropagation();
        onDelete(playbook);
    };
    return (_jsxs("div", { "data-testid": "playbook-item", "data-status": status, onClick: () => onClick(playbook), className: cn(`p-4 rounded-lg flex justify-between items-center cursor-pointer border`, getBgStyle()), children: [_jsx("span", { children: name }), _jsxs("div", { className: "flex items-center gap-2", children: [_jsx("button", { onClick: handleDeleteClick, className: "p-1 rounded hover:bg-muted transition-colors", "aria-label": "Delete playbook", children: _jsx(Trash2, { className: "h-4 w-4 text-muted-foreground hover:text-destructive" }) }), status === 'Processing' && _jsx(LoadingSpinner, {}), status === 'Completed' && _jsx(CircleCheck, { className: 'text-success' }), status === 'Failed' && _jsx(XCircle, { className: 'text-error' })] })] }));
};
export default PlaybookListItem;
